import { useIntl } from 'react-intl';
import { Typography } from 'iglooform';
import styles from './index.less';

interface IOverviewCardProps {
  icon: string;
  title: string;
  list: { text: string; value: React.ReactNode }[];
}

const OverviewCard = (props: IOverviewCardProps) => {
  const { formatMessage } = useIntl();
  const { list = [], icon, title } = props;

  const OverviewCardBody = list.map((item, idx) => {
    return (
      <div key={idx} className={styles.overviewCardBodyList}>
        <Typography level="body1">{item?.text ?? ''}</Typography>
        <Typography level="h4">{item?.value ?? ''}</Typography>
      </div>
    );
  });

  return (
    <div className={styles.overviewCard}>
      <div className={styles.overviewCardHead}>
        <img src={icon} alt="" />
        <div className={styles.overviewCardHeadTextWrap}>
          <Typography level="body1" wrapElement="div">
            {title}
          </Typography>
          <Typography level="body2" wrapElement="div">
            {formatMessage({ id: 'In chosen period' })}
          </Typography>
        </div>
      </div>
      <div className={styles.overviewCardBody}>{OverviewCardBody}</div>
    </div>
  );
};

export default OverviewCard;
